var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "65 70 170 170",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 219.59965,175.35096 H 81.093962 c -6.888052,0 -12.56604,5.52489 -12.56604,12.2272 v 38.04021 c 0,6.70232 5.677988,12.22721 12.56604,12.22721 H 219.59965 c 6.88806,0 12.56604,-5.52489 12.56604,-12.22721 v -38.04021 c -0.0931,-6.70231 -5.67798,-12.2272 -12.56604,-12.2272 z m -43.84151,38.22135 h -25.41133 -25.41133 l -3.44402,-14.12922 h 8.1912 l 1.11698,8.6949 h 19.54717 19.54717 l 1.11698,-8.6949 h 8.1912 z",
    id: "path29",
    style: {
      strokeWidth: 0.918183
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g35",
    transform: "matrix(1.0894706,0,0,1.17735,-5.7901877,-9.0717596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 123.4,68.6 c 0,-0.5 0.1,-1 0.1,-1.5 H 98.6 l -24.4,92.4 h 11.5 l 21.5,-81.4 h 16.3 v -9.5 z",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188.8,67.1 H 164 c 0.1,0.5 0.1,1 0.1,1.5 v 9.6 h 16.1 l 21.5,81.4 h 11.5 z",
    id: "path33"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 167.31571,120.47609 V 95.946414 c 0,-1.792554 -1.42752,-3.207727 -3.23571,-3.207727 h -26.07604 c -1.8082,0 -3.23571,1.415173 -3.23571,3.207727 v 24.529676 h -18.1771 c -1.80819,0 -2.37919,1.13215 -1.33235,2.54732 l 33.68948,44.15341 c 1.04685,1.41518 2.85504,1.41518 3.99706,0 l 33.68948,-44.15341 c 1.04685,-1.41517 0.47584,-2.54732 -1.33235,-2.54732 z",
    id: "path37",
    style: {
      strokeWidth: 0.947556
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.726cbbfd1735efd811f8ef1cf53c7894.svg";
export { ForwardRef as ReactComponent };